module.exports = __webpack_public_path__ + "img/jd-logo.9d325d82.png";